var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height d-flex justify-center"},[_c('div',[_c('v-img',{attrs:{"src":_vm.logoUrl}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }